import {
  closestCenter,
  pointerWithin,
  rectIntersection,
  type CollisionDetection,
} from "@dnd-kit/core";

interface SortableData {
  sortable?: { containerId?: string | number };
}

function containerOf(data: unknown): string | number | undefined {
  return (data as SortableData | undefined)?.sortable?.containerId;
}

// Task rows are full-width, so the default rectIntersection often picks a neighbour
// row over a much narrower sidebar drop target even when the pointer is clearly inside
// the sidebar item. pointerWithin tracks the actual cursor; rectIntersection is the
// fallback when the cursor falls in a gap between sortable items.
//
// Both come up empty once the row is carried past the edge of its own list — above
// the first row is the everyday case: to put a task first you naturally lift it over
// the top, and the pointer ends up on the input above. Snapping back there reads as
// "can't drop at the top", so the last resort is the nearest sibling in the same
// SortableContext: the first row when above the list, the last when below it. Other
// containers stay out of it — a subtask group or the sidebar is never a stand-in.
export const collisionDetection: CollisionDetection = (args) => {
  const pointer = pointerWithin(args);
  if (pointer.length > 0) return pointer;

  const intersecting = rectIntersection(args);
  if (intersecting.length > 0) return intersecting;

  const containerId = containerOf(args.active.data.current);
  if (containerId === undefined) return [];

  const siblings = args.droppableContainers.filter(
    (container) => containerOf(container.data.current) === containerId,
  );
  return closestCenter({ ...args, droppableContainers: siblings });
};
